<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">特別指示書</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">指示書区分</label>
          <div class="list-input-content">
            <app-code-combo-box id="cmb_SpeciallyIndicationDiv" #cmb_SpeciallyIndicationDiv
              [subid]="'cmb_SpeciallyIndicationDiv'" [required]="true" [codeDiv]="'ctp070'" [blank]="false"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw6600Model.indicationDiv"
              [initFocusItem]="txti_OrderCode" value='1'>
            </app-code-combo-box>
          </div>

          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input id="txti_OrderCode" #txti_OrderCode [subid]="'txti_OrderCode'"
              [catalogIDField]="lbl_CatalogId" [forcedEnabledMode]="'true'" [tabindex]="0" [autofocus]="true"
              [required]="true" [(ngModel)]="kymw6600Model.orderCode">
            </app-order-code-text-input>
          </div>

          <label class="list-input-title">配達企画回(翌週)</label>
          <div class="list-input-content">
            <input type="text" class="deliv-catalog" id="lbl_CatalogId" #lbl_CatalogId readonly>
          </div>

          <label class="list-input-title">部門</label>
          <div class="list-input-content">
            <app-class-code-combo-box class="list-input-content" class="combo-box-normal" id="cmb_ClassCode"
              [subid]="'cmb_ClassCode'" [initFocusItem]="txti_OrderCode" [forcedEnabledMode]="'true'" [tabindex]="0"
              [(ngModel)]="kymw6600Model.classCode"></app-class-code-combo-box>
          </div>
          
          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <app-medium-type-combo-box class="list-input-content" id="cmb_MediumType" [subid]="'cmb_MediumType'"
              [forcedEnabledMode]="'true'" [initFocusItem]="txti_OrderCode" [tabindex]="0"
              [(ngModel)]="kymw6600Model.mediumType"></app-medium-type-combo-box>
          </div>

          <label class="list-input-title">バイヤーコード</label>
          <div class="list-input-content">
            <app-code-combo-box class="list-input-content" id="cmb_BuyerCode" [subid]="'cmb_BuyerCode'" [codeDiv]="'ct357'"
              [initFocusItem]="txti_OrderCode" [labelField]="'codeValueName'" [forcedEnabledMode]="'true'" [tabindex]="0"
              [(ngModel)]="kymw6600Model.buyerCode">
            </app-code-combo-box>
          </div>
        </div>        
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" id="btn_Output" (click)="eventListOut_CLICKHandler()"
            forcedEnabledMode="true" [tabindex]="0">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
